import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router'
import Navigation from '@App/navigation'
import RootScene from '@Scenes/RootScene'
import RootLayout from '@Scenes/RootLayout'
import RootErrorBoundary from '@Scenes/ErrorBoundary/RootErrorBoundary'
import RequireAuth from '@Components/Utility/RequireAuth'
import createRightsholderRoutes from '@App/routes/rightsholder'
import createRegistrationMemberRoutes from './registration/member'
import createRegistrationMemberRoutesV2 from '@App/routes/registration/member/index.v2'
import createSongwriterRoutes from '@App/routes/songwriter'
import createRegistrationSongwriterRoutes from '@App/routes/registration/songwriter'
import createNewUserRoutes from '@App/routes/registration/newUser'
import { ErrorBoundary } from 'react-error-boundary'
import { createPublicRoutes, createAuthRoutes } from '@App/routes/common-routes'

const createRouter = () => {
    const registrationMemberRoutes = createRegistrationMemberRoutes()
    const registrationMemberRoutesV2 = createRegistrationMemberRoutesV2()
    const rightsholderRoutes = createRightsholderRoutes()
    const songwriterRoutes = createSongwriterRoutes()
    const songwriterRegistrationRoutes = createRegistrationSongwriterRoutes()
    const newUserRoutes = createNewUserRoutes()
    return createBrowserRouter([
        {
            path: '',
            element: (
                <ErrorBoundary fallbackRender={({ error }) => <RootErrorBoundary error={error} />}>
                    <RootLayout />
                </ErrorBoundary>
            ),
            errorElement: <RootErrorBoundary />,
            children: [
                ...createPublicRoutes(),
                ...createAuthRoutes(),
                registrationMemberRoutes,
                registrationMemberRoutesV2,
                rightsholderRoutes,
                songwriterRoutes,
                songwriterRegistrationRoutes,
                newUserRoutes,
                {
                    path: '',
                    element: (
                        <RequireAuth>
                            <RootScene />
                        </RequireAuth>
                    ),
                },
                {
                    path: '*',
                    element: <Navigate replace to={Navigation.home.root()} />,
                },
            ],
        },
    ])
}

export default createRouter
